import { useTranslation } from 'react-i18next';

// Formats an age object into a human-friendly string for tooltips and labels
export function formatAgeLabel(
  ageObj: { years: number; months: number; days: number } | undefined,
  intervalType: string | undefined
): string {
  const { t } = useTranslation(['images-tab']);

  if (!ageObj) {
    return '';
  }

  const { years = 0, months = 0, days = 0 } = ageObj;

  if (intervalType === 'week') {
    // Convert everything to days first, then to weeks
    const totalDays = years * 365 + months * 30 + days;
    const totalWeeks = Math.floor(totalDays / 7);
    const remDays = totalDays % 7;
    const parts: string[] = [];

    if (totalWeeks > 0) {
      parts.push(
        `${totalWeeks} ${
          totalWeeks > 1
            ? t('weeks', { ns: 'images-tab' })
            : t('week', { ns: 'images-tab' })
        }`
      );
    }

    if (remDays > 0) {
      parts.push(
        `${remDays} ${
          remDays > 1
            ? t('days', { ns: 'images-tab' })
            : t('day', { ns: 'images-tab' })
        }`
      );
    }

    return parts.length > 0
      ? parts.join(', ')
      : `0 ${t('days', { ns: 'images-tab' })}`;
  } else if (intervalType === 'month') {
    const totalMonths = years * 12 + months;
    const parts: string[] = [];

    if (totalMonths > 0) {
      parts.push(
        `${totalMonths} ${
          totalMonths > 1
            ? t('months', { ns: 'images-tab' })
            : t('month', { ns: 'images-tab' })
        }`
      );
    }

    if (days > 0) {
      parts.push(
        `${days} ${
          days > 1
            ? t('days', { ns: 'images-tab' })
            : t('day', { ns: 'images-tab' })
        }`
      );
    }

    return parts.length > 0
      ? parts.join(', ')
      : `0 ${t('days', { ns: 'images-tab' })}`;
  } else {
    // fallback: show all units
    const parts: string[] = [];

    if (years > 0) {
      parts.push(
        `${years} ${
          years > 1
            ? t('years', { ns: 'images-tab' })
            : t('year', { ns: 'images-tab' })
        }`
      );
    }

    if (months > 0) {
      parts.push(
        `${months} ${
          months > 1
            ? t('months', { ns: 'images-tab' })
            : t('month', { ns: 'images-tab' })
        }`
      );
    }

    if (days > 0) {
      parts.push(
        `${days} ${
          days > 1
            ? t('days', { ns: 'images-tab' })
            : t('day', { ns: 'images-tab' })
        }`
      );
    }

    return parts.length > 0
      ? parts.join(', ')
      : `0 ${t('days', { ns: 'images-tab' })}`;
  }
}
